import { generatePath } from "@routes/utils";

import type { IExtractParams } from "@routes";

const pathBase = `/geo/currencies/`;
const pathById = `${pathBase}:currencyId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const currencies = {
  getAll: (param: IPathBaseParam) => generatePath(pathBase, param),
  get: (param: IPathByIdParam) => generatePath(pathById, param),
} as const;
